import { t } from "i18next";
import { toast } from "react-toastify";

let lastErrorMessage = "";
let lastErrorTime = 0;

export const handleApiError = (
  defaultMessageKey = null,
  error,
  delay = 3000
) => {
  const message =
    error?.response?.data?.message ||
    (defaultMessageKey ? t(defaultMessageKey) : "Something went wrong!");

  const now = Date.now();

  if (message !== lastErrorMessage || now - lastErrorTime > delay) {
    if (error?.suppressToast) return;
    toast.error(message);
    lastErrorMessage = message;
    lastErrorTime = now;
  }
};
